import React from "react";
import { useStateContext } from "../contexts/ContextProvider";
import { DateTime } from "luxon";

const ExpensesCard = (props) => {
  const { expenses, setCurrentExpenseId } = props;
  const { handleModal } = useStateContext();

  return (
    <div className="flex justify-center h-2/3 pt-2 px-5 mb-40">
      <div className="w-full md:max-w-[500px] border-gray-300 border-1 rounded-2xl overflow-clip overflow-y-scroll">
        {/* <div className="grid grid-cols-4 h-10 w-full bg-gray-100 border-gray-300 border-b-1 py-2">
          <div className="pl-2">Date</div>
          <div className="col-span-2 text-left pl-8">Expense</div>
          <div className="text-right pr-5">Total</div>
        </div> */}
        {expenses.length > 0 && (
          <div>
            <ul className=" px-1 py-2 mb-[300px]">
              {expenses.map((item, index) => {
                return (
                  <li
                    key={item.id}
                    className={`grid grid-cols-2 items-center border-gray-300 border-2
                   hover:border-snappily-orange rounded-xl m-0.5 py-2 my-1 capitalize 
                   cursor-pointer px-2 ${index % 2 === 0 ? "" : "bg-gray-200"}`}
                    onClick={() => {
                      setCurrentExpenseId(item.id);
                      handleModal("editExpense");
                    }}
                  >
                    <div className="col-span-2">
                      <div
                        className="text-lg text-blue-500 hover:text-blue-700 truncate 
                    text-ellipsis"
                      >
                        {item.payee}
                      </div>
                      <div>{item.type}</div>
                    </div>
                    <div className="text-sm md:text-base text-left">
                      {DateTime.fromFormat(
                        item.datePaid,
                        "yyyy-MM-dd"
                      ).toFormat("MM/dd/yyyy")}
                    </div>
                    <div className="text-right">
                      {Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        maximumFractionDigits: 2,
                      }).format(item.total / 100)}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
        {expenses.length === 0 && (
          <ul className="flex items-center h-52">
            <div className="flex justify-center w-full text-gray-400">
              No expensess have been added yet.
            </div>
          </ul>
        )}
      </div>
    </div>
  );
};

export default ExpensesCard;
